import request from "@/utils/request";

// 列表(主数据列表)
export function loadAppConsumerStoreScanGetRaffleRecordListDataApi(data) {
  return request({
    url: "web/appConsumerStoreScanGetRaffleRecord/listData",
    method: "post",
    data
  });
}
// 导出
export function loadAppConsumerStoreScanGetRaffleRecordExportDataApi(data) {
  return request({
    url: "web/appConsumerStoreScanGetRaffleRecord/exportData",
    method: "post",
    data
  });
}
// 导出图片
export function loadAppConsumerStoreScanGetRaffleRecordExportPicZipApi(data) {
  return request({
    url: "web/appConsumerStoreScanGetRaffleRecord/exportPicZip",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateAppConsumerStoreScanGetRaffleRecordApi(data) {
  return request({
    url: "web/appConsumerStoreScanGetRaffleRecord/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initAppConsumerStoreScanGetRaffleRecordApi(data) {
  return request({
    url: "web/appConsumerStoreScanGetRaffleRecord/init",
    method: "post",
    data
  });
}

// 根据条件查询
export function findAppConsumerStoreScanGetRaffleRecordByConditionApi(data) {
  return request({
    url: "web/appConsumerStoreScanGetRaffleRecord/findListByCondition",
    method: "post",
    data
  });
}
